import { render, staticRenderFns } from "./connect-icon.vue?vue&type=template&id=efa2e404&scoped=true&"
import script from "./connect-icon.vue?vue&type=script&lang=js&"
export * from "./connect-icon.vue?vue&type=script&lang=js&"
import style0 from "./connect-icon.vue?vue&type=style&index=0&id=efa2e404&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "efa2e404",
  null
  
)

export default component.exports